<div *ngIf="(loaderService.visible$ | async) && !inline" class="loader-background">
  <div class="loader-container">
    <div class="spinner-container">
      <app-spinner></app-spinner>
    </div>

    <div class="text-content">
      <h2>Please Wait...</h2>
      <p [innerHTML]="serviceMessage$ | async"></p>
    </div>
  </div>
</div>

<div *ngIf="inline" class="inline-loader">
  <div class="spinner-container">
    <app-spinner></app-spinner>
  </div>

  <div class="text-content">
    <h2>Please Wait...</h2>
    <p><ng-content></ng-content></p>
  </div>
</div>
